import { ReactNode } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Download, Maximize2 } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

interface ChartContainerProps {
  title: string;
  description?: string;
  children: ReactNode;
  isLoading?: boolean;
  onExport?: () => void;
  onExpand?: () => void;
  className?: string;
}

export function ChartContainer({
  title,
  description,
  children,
  isLoading = false,
  onExport,
  onExpand,
  className = "",
}: ChartContainerProps) {
  if (isLoading) {
    return (
      <Card className={className}>
        <CardHeader>
          <Skeleton className="h-6 w-48" />
          {description && <Skeleton className="h-4 w-64 mt-2" />}
        </CardHeader>
        <CardContent>
          <Skeleton className="h-[300px] w-full" />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className={className}>
      <CardHeader>
        <div className="flex items-start justify-between">
          <div className="space-y-1">
            <CardTitle className="text-lg">{title}</CardTitle>
            {description && (
              <CardDescription>{description}</CardDescription>
            )}
          </div>
          <div className="flex items-center gap-2">
            {onExport && (
              <Button
                variant="ghost"
                size="icon"
                onClick={onExport}
                title="Exportar gráfico"
              >
                <Download className="h-4 w-4" />
              </Button>
            )}
            {onExpand && (
              <Button
                variant="ghost"
                size="icon"
                onClick={onExpand}
                title="Expandir"
              >
                <Maximize2 className="h-4 w-4" />
              </Button>
            )}
          </div>
        </div>
      </CardHeader>
      <CardContent>{children}</CardContent>
    </Card>
  );
}
